/* ==========================================================================
   Bronzed By Carrot — carrot-tan PDP behaviour (sticky pop-up ATC bar).
   Defensive IIFE. Builds a sticky bar from the live DOM, reveals it once the
   user scrolls past the native add-to-cart button (scroll math, NOT
   IntersectionObserver), proxies clicks to the native button so Dawn's AJAX
   add + cart drawer fire natively. Re-inits on shopify:section:load.
   No swiper code here.
   ========================================================================== */
(function () {
  'use strict';

  if (!document.body || !document.body.hasAttribute('data-bc-pdp')) return;

  var BAR_ID = 'bc-sticky-atc';
  var state = {
    bar: null,
    titleEl: null,
    priceEl: null,
    raf: 0,
  };

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  /* Always re-query the native add button — Dawn swaps this node on
     state changes (ready/loading/added). */
  function nativeAddButton() {
    return qs('product-form button[name="add"], .product-form__submit');
  }

  function getNativePrice() {
    var priceWrap = qs(
      '.product__info-container .price, [id^="price-"] .price, .price'
    );
    if (!priceWrap) return '';
    // Prefer the visible sale/last price, fall back to regular.
    var item =
      priceWrap.querySelector('.price-item--sale:not(.hidden)') ||
      priceWrap.querySelector('.price-item--last:not(.hidden)') ||
      priceWrap.querySelector('.price-item--regular');
    return item ? item.textContent.trim() : priceWrap.textContent.trim();
  }

  function getNativeTitle() {
    var t = qs('.product__info-container .product__title h1, .product__title h1');
    return t ? t.textContent.trim() : (document.title || 'Add to cart');
  }

  function getGalleryImageSrc() {
    var img = qs(
      '.product__media-wrapper img, .product__media img, .product-media-container img'
    );
    if (!img) return '';
    return img.currentSrc || img.src || '';
  }

  function buildBar() {
    if (document.getElementById(BAR_ID)) {
      state.bar = document.getElementById(BAR_ID);
      state.titleEl = qs('.bc-sticky-atc__title', state.bar);
      state.priceEl = qs('.bc-sticky-atc__price', state.bar);
      return;
    }

    var bar = document.createElement('div');
    bar.id = BAR_ID;
    bar.className = 'bc-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');

    var imgSrc = getGalleryImageSrc();
    var mediaHtml = imgSrc
      ? '<div class="bc-sticky-atc__media"><img class="bc-sticky-atc__img" src="' +
        imgSrc.replace(/"/g, '&quot;') +
        '" alt="" loading="lazy" decoding="async"></div>'
      : '';

    bar.innerHTML =
      mediaHtml +
      '<div class="bc-sticky-atc__info">' +
      '<span class="bc-sticky-atc__title"></span>' +
      '<span class="bc-sticky-atc__price"></span>' +
      '</div>' +
      '<button type="button" class="bc-sticky-atc__btn"><span>Add to cart</span></button>';

    document.body.appendChild(bar);

    state.bar = bar;
    state.titleEl = qs('.bc-sticky-atc__title', bar);
    state.priceEl = qs('.bc-sticky-atc__price', bar);

    state.titleEl.textContent = getNativeTitle();
    syncPrice();

    qs('.bc-sticky-atc__btn', bar).addEventListener('click', function () {
      var btn = nativeAddButton();
      if (btn && !btn.hasAttribute('disabled')) btn.click();
    });
  }

  function syncPrice() {
    if (!state.priceEl) return;
    var p = getNativePrice();
    if (p) state.priceEl.textContent = p;

    /* Mirror sold-out / availability state onto the sticky button. */
    var native = nativeAddButton();
    var sticky = state.bar && qs('.bc-sticky-atc__btn', state.bar);
    if (native && sticky) {
      var span = sticky.querySelector('span');
      var nativeSpan = native.querySelector('span');
      if (nativeSpan && span) span.textContent = nativeSpan.textContent.trim();
      var disabled = native.hasAttribute('disabled');
      sticky.disabled = disabled;
      sticky.style.opacity = disabled ? '0.6' : '';
    }
  }

  /* Reveal once the user has scrolled PAST the bottom of the native add
     button; hide again when it scrolls back into view. Pure scroll math. */
  function updateVisibility() {
    state.raf = 0;
    if (!state.bar) return;

    var anchor =
      qs('product-form .product-form__buttons') ||
      nativeAddButton() ||
      qs('.product-form');
    if (!anchor) return;

    var rect = anchor.getBoundingClientRect();
    var pastNative = rect.bottom < 0; // native button fully above viewport top
    var atVeryBottom =
      window.innerHeight + window.scrollY >=
      document.documentElement.scrollHeight - 4;

    var show = pastNative && !atVeryBottom;
    state.bar.classList.toggle('is-visible', show);
    state.bar.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  function onScroll() {
    if (state.raf) return;
    state.raf = window.requestAnimationFrame(updateVisibility);
  }

  function bindVariantSync() {
    /* Keep price/title in sync on variant change. Capture phase catches the
       native radio/select change before Dawn re-renders price; we re-read
       shortly after so the DOM has updated. */
    document.addEventListener(
      'change',
      function (e) {
        if (
          e.target &&
          e.target.closest &&
          e.target.closest('product-info, variant-selects, .product-form')
        ) {
          window.setTimeout(syncPrice, 120);
        }
      },
      true
    );

    /* Dawn pubsub: variant change publishes 'variant:change'. The global
       subscribe() helper lives on window when pubsub.js is loaded. */
    if (typeof window.subscribe === 'function') {
      try {
        window.subscribe('variant:change', function () {
          window.setTimeout(syncPrice, 60);
        });
      } catch (err) {
        /* PUB_SUB_EVENTS key may differ; the capture listener covers it. */
      }
    }
    document.addEventListener('variant:change', function () {
      window.setTimeout(syncPrice, 60);
    });
  }

  var bound = false;
  function init() {
    if (!document.body.hasAttribute('data-bc-pdp')) return;
    buildBar();
    updateVisibility();
    syncPrice();
    if (bound) return;
    bound = true;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    bindVariantSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor re-renders the product section without a page load. */
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(init, 50);
  });
})();


/* === Buy-column empty-child sweep (from buy-box redesign) === */
/* Defensive empty-child sweep for .product__info-container — collapses any
   OTHER genuinely-empty direct child that Dawn/apps leave behind, so no stray
   wrapper reintroduces a vertical gap. No IntersectionObserver. Runs once.
   NEVER touches: the #ss-* injection anchors (CSS handles them; their content
   is a SIBLING, not inside), the installment wrapper (CSS handles it), or
   non-visual nodes (script/style/template/noscript). Only hides a child with
   no text AND no rendered child element. */
(function () {
  if (!document.body || !document.body.hasAttribute('data-bc-pdp')) return;
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, TEMPLATE: 1, NOSCRIPT: 1 };
  function sweep() {
    var box = document.querySelector('[data-bc-pdp] .product__info-container');
    if (!box) return;
    Array.prototype.forEach.call(box.children, function (el) {
      if (SKIP_TAGS[el.tagName]) return;
      if (el.id && el.id.indexOf('ss-') === 0) return;                 // SS anchor (CSS handles)
      if (el.querySelector && el.querySelector('[id^="ss-"]')) return; // wraps an SS anchor
      if (el.id && el.id.indexOf('product-form-installment') === 0) return;       // CSS handles
      if (el.querySelector && el.querySelector('[id^="product-form-installment"]')) return;
      var hasText = el.textContent && el.textContent.trim().length > 0;
      var hasEl = el.querySelector && el.querySelector('*');
      if (!hasText && !hasEl) {
        el.style.display = 'none';
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep);
  } else {
    sweep();
  }
})();